import { useLayout } from '@approvalmax/ui/src/components';
import { selectors } from 'modules/common';
import { hocs as pageHocs } from 'modules/page';
import { useDispatch, useSelector } from 'modules/react-redux';
import { useUnmount } from 'react-use';
import { useHideRequestCreation } from 'shared/components';

import { leavePage } from './actions';
import { Content } from './components';
import { PAGE_ID } from './config';
import useEditRequestPageData from './hooks/useEditRequestPageData';
import { usePageRedesign } from './hooks/usePageRedesign';
import { Loading } from './loading';
import { LoadingOld } from './loadingOld';

const Page = () => {
    const dispatch = useDispatch();
    const { isInitialLoading } = useEditRequestPageData();
    const activePageId = useSelector(selectors.navigation.getActivePageId);
    const { isPageRedesign } = usePageRedesign();

    useLayout({ hasHeader: true, hasDrawer: false });
    useHideRequestCreation();

    useUnmount(() => {
        dispatch(leavePage());
    });

    if (isInitialLoading || activePageId !== PAGE_ID) {
        return isPageRedesign ? <Loading /> : <LoadingOld />;
    }

    return <Content />;
};

export default pageHocs.withProtected({ Page });
